/**
 * 🔒 The Internal Notes tile and a Deal stage-card row's notes stand three notes
 * tall and scroll inside for the rest (decision 0950), one list drawn by one
 * construction in both. Product owner, 2026-09-26: *"in both set it
 * to 3 note view then scroll."*
 */
export const NOTE_LIST_ROWS = 3;

/**
 * The height a notes list is held to, in pixels, from the tops of its rows as
 * drawn: the distance from the first row's top to the top of the row after the
 * last one shown, so the cap is exactly that many notes whatever each is tall.
 * A list of no more rows than it shows is not held at all, and answers null.
 */
export function noteListCap(rowTops: readonly number[], rows: number = NOTE_LIST_ROWS): number | null {
  if (!(rows > 0) || rowTops.length <= rows) return null;
  const first = rowTops[0]!;
  const next = rowTops[rows]!;
  const cap = next - first;
  return cap > 0 ? cap : null;
}
